module.exports = __webpack_public_path__ + "static/media/ahack1.5dea2c9a.jpg";